import { render, staticRenderFns } from "./spoiled.vue?vue&type=template&id=1fad500b&"
import script from "./spoiled.vue?vue&type=script&lang=js&"
export * from "./spoiled.vue?vue&type=script&lang=js&"
import style0 from "./spoiled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports